import { render, staticRenderFns } from "./PilihRegistrasi.vue?vue&type=template&id=09677324&scoped=true&"
import script from "./PilihRegistrasi.vue?vue&type=script&lang=js&"
export * from "./PilihRegistrasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09677324",
  null
  
)

export default component.exports